<!-- <button mat-button class="links tdo-button tdo-save" (click)="useNewLoginPage = !useNewLoginPage">Switch</button> -->
<div class="login-container">
  <!-- LEFT: Brand Panel -->
  <div class="brand-panel">
    <!-- Decorative dots (echo of logo) -->
    <div class="deco-dots-small">
      <span></span><span></span><span></span><span></span>
    </div>
    <div class="deco-dots-large">
      <span [style.opacity]="0.3"></span>
      <span [style.opacity]="0.7"></span>
      <span [style.opacity]="0.5"></span>
      <span [style.opacity]="0.9"></span>
    </div>

    <div class="brand-content" [class.mounted]="mounted()">
      <!-- TDOS Logo SVG -->
      <div class="logo-wrapper">
        <svg viewBox="0 0 2634.48 813.5" xmlns="http://www.w3.org/2000/svg" class="logo-svg">
          <!-- T and D -->
          <path fill-rule="evenodd" fill="#fff"
            d="M929.68,644.7h0s-198.81,0-198.81,0V134.67h198.81c140.62,0,255.02,114.4,255.02,255.02s-114.4,255.01-255.02,255.01h0ZM929.68.71h-332.81v.09H.48v133.96h231.2v645.66h134V134.76h231.2v643.9h332.81c214.52,0,389.02-174.49,389.02-388.97S1144.19.71,929.68.71h0Z" />
          <!-- O ring -->
          <path fill-rule="evenodd" fill="#fff"
            d="M1708.81,644.95c-140.63,0-254.63-114-254.63-254.63s114-254.63,254.63-254.63,254.64,114,254.64,254.63-114.01,254.63-254.64,254.63M1708.81.21c-215.45,0-390.1,174.66-390.1,390.11s174.65,390.11,390.1,390.11,390.11-174.66,390.11-390.11S1924.25.21,1708.81.21" />
          <!-- S -->
          <path fill="#fff"
            d="M2074.6,573.72h157.35c1.13,55.46,55.47,101.89,127.92,101.89s116.61-38.51,116.61-93.97c0-43.01-31.71-73.58-98.5-93.97l-95.09-27.17c-170.94-45.28-201.51-148.3-201.51-218.48,0-139.25,120-235.47,269.43-235.47s260.36,89.44,260.36,237.72h-157.34c0-55.46-38.5-98.47-106.42-98.47-61.13,0-107.55,40.74-107.55,92.82,0,19.24,5.66,58.86,87.18,82.64l87.16,24.89c117.74,35.09,220.75,95.09,220.75,227.54,0,155.1-132.46,239.99-279.62,239.99-166.41,0-280.74-103.01-280.74-239.99h0Z" />
          <!-- Four dots -->
          <path fill="#7f5ba5"
            d="M1814.75,390.32c-.13,0-.25,0-.38,0s-.24,0-.37,0c-58.14-.2-105.2-47.39-105.2-105.57s47.27-105.57,105.57-105.57c25.84,0,49.51,9.28,67.86,24.7,4.5,4.18,8.84,8.52,13.02,13.01,15.41,18.35,24.69,42.02,24.69,67.86,0,58.18-47.06,105.37-105.19,105.57" />
          <path fill="#a380ba"
            d="M1814.38,601.46c-58.3,0-105.57-47.27-105.57-105.57s47.06-105.37,105.2-105.57h.74c58.13.2,105.19,47.39,105.19,105.57,0,25.83-9.28,49.5-24.68,67.84-4.19,4.51-8.53,8.85-13.05,13.05-18.34,15.4-42.01,24.68-67.84,24.68" />
          <path fill="#cbb2d5"
            d="M1603.24,601.46c-25.82,0-49.46-9.27-67.82-24.66-4.52-4.2-8.89-8.58-13.09-13.1-15.39-18.34-24.66-42-24.66-67.82,0-58.18,47.06-105.37,105.2-105.57h.74c58.13.2,105.19,47.39,105.19,105.57s-47.26,105.57-105.57,105.57" />
          <path fill="#e5daeb"
            d="M1603.61,390.32c-.13,0-.25,0-.38,0s-.24,0-.37,0c-58.14-.2-105.2-47.39-105.2-105.57,0-25.82,9.28-49.49,24.67-67.83,4.19-4.51,8.55-8.87,13.07-13.06,18.34-15.4,42-24.67,67.83-24.67,58.31,0,105.57,47.27,105.57,105.57s-47.06,105.37-105.19,105.57" />
        </svg>
      </div>

      <!-- Tagline -->
      <p class="tagline">Your Endodontic Practice Operating System</p>

      <!-- Description -->
      <p class="description">
        Purpose-built clinical workflows, digital imaging, and practice
        management for endodontists.
      </p>

      <!-- Accent bar -->
      <div class="accent-bar"></div>
    </div>
  </div>

  <!-- RIGHT: Login Form -->
  <div class="form-panel">
    <div class="form-content" [class.mounted]="mounted()">
      @if (logoUrl) {
        <img class="location-logo" [src]="logoUrl" alt="Practice logo"
          data-cy="auth-login-page-practice-logo" />
      }
      <h2 class="form-title">Welcome back</h2>
      <p class="form-subtitle">
        @if (!loginMode) {
          Password Reset
        }
        @else if (loginType == 'referring doctor') {
          Referrer Login
        }        
        @else {
          Sign in to your practice
        }
      </p>

      @if (passwordResetTokenAvailable) {
      <form (keydown.enter)="$event.preventDefault()" data-cy="auth-login-page-reset-password-form" class="login-form">

        <!-- Password -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-password-label">New Password @if (!passwordChange) {
              <span style="color: red;">*</span>
              }</mat-label>
          </div>
          <div class="password-wrapper">
            <mat-form-field class="w-100" data-cy="auth-login-page-password-field">
              <input matInput data-cy="auth-login-page-password-input" [type]="showPassword ? 'text' : 'password'"
                name="passwordChange" [attr.autocomplete]="showPassword ? 'off' : 'current-password'" maxlength="25"
                id="passwordChange" (keyup.enter)="resetPassword()" [(ngModel)]="passwordChange" value="{{passwordChange}}"
                required placeholder="Enter your new password" (focus)="focusedField = 'passwordChange'"
                (blur)="focusedField = ''" [class.focused]="focusedField === 'passwordChange'" />
              <mat-icon matSuffix (mousedown)="showPasswords()" (mouseleave)="hidePasswords()"
                (mouseup)="hidePasswords()" class="toggle-password"
                data-cy="auth-login-page-password-toggle">{{showPassword ? 'visibility' :
                'visibility_off'}}</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <!-- Password -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-password-label">Confirm Password @if (!passwordConfirmation) {
              <span style="color: red;">*</span>
              }</mat-label>
          </div>
          <div class="password-wrapper">
            <mat-form-field class="w-100" data-cy="auth-login-page-password-field">
              <input matInput data-cy="auth-login-page-password-input" [type]="showPassword ? 'text' : 'password'"
                name="passwordConfirmation" [attr.autocomplete]="showPassword ? 'off' : 'current-password'" maxlength="25"
                id="passwordConfirmation" (keyup.enter)="resetPassword()" [(ngModel)]="passwordConfirmation"
                value="{{passwordConfirmation}}" required placeholder="Confirm your new password"
                (focus)="focusedField = 'passwordConfirmation'" (blur)="focusedField = ''"
                [class.focused]="focusedField === 'passwordConfirmation'" />
              <mat-icon matSuffix (mousedown)="showPasswords()" (mouseleave)="hidePasswords()"
                (mouseup)="hidePasswords()" class="toggle-password"
                data-cy="auth-login-page-password-toggle">{{showPassword ? 'visibility' :
                'visibility_off'}}</mat-icon>
            </mat-form-field>
          </div>
        </div>

        @if (!passwordResetConfirmation) {
          <div class="password-requirements" data-cy="auth-login-page-password-requirements">
            <div class="password-requirements-title">Password requirements:</div>
            <ul>
              <li>At least 10 characters.</li>
              <li>At least one lowercase letter ('a'-'z').</li>
              <li>At least one uppercase letter ('A'-'Z').</li>
              <li>At least one non alphanumeric character.</li>
              <li>Passwords must have at least one digit ('0'-'9').</li>
            </ul>
          </div>
        }

        @if (passwordResetConfirmation) {
          <div data-cy="auth-login-page-password-reset-success-message" class="loginSuccess">
            Password reset successful. Please return to login and sign in.
          </div>
        }
        @if (!passwordResetConfirmation && passwordChangeMessages.length > 0) {
          <div data-cy="auth-login-page-password-reset-error-message" class="loginError">
            @for (msg of passwordChangeMessages; track msg) {
              <div>{{msg}}</div>
            }
          </div>
        }

        <!-- Submit -->
        <button mat-button type="submit" class="btn-signin" (click)="resetPassword()"
          [disabled]="isLoading || !passwordChange || !passwordConfirmation || passwordChange != passwordConfirmation || passwordResetConfirmation" data-cy="auth-login-page-password-reset-request-btn">
          @if (!isLoading) {
          Reset Password
          }
          @if (isLoading) {
          <mat-spinner class="login-spinner" [diameter]="20" data-cy="auth-login-page-spinner"></mat-spinner>
          }
        </button>
        <button mat-button class="forgot-link" (click)="showLogin()"
          data-cy="auth-login-page-password-reset-cancel-link">
          @if (!passwordResetConfirmation) {
          Cancel
          }
          @if (passwordResetConfirmation) {
          Back to Login
          }
        </button>
      </form>

      }
      @else if (loginMode) {
      <form (keydown.enter)="$event.preventDefault()" data-cy="auth-login-page-form" class="login-form">


        @if (loginType != 'referring doctor') {
        <!-- Location -->
        <div class="field">
          
          <div class="label-row">
          <mat-label class="label-row" data-cy="auth-login-page-location-label">Location @if (selectedLocation ==
            'null' || !selectedLocation) {
            <span style="color: red;">*</span>
            }</mat-label>
            </div>
          <mat-form-field class="w-100 field" data-cy="auth-login-page-location-field">
            <mat-select (ngModelChange)="locationSelected($event)" data-cy="auth-login-page-location-select"
              name="location" autocomplete="off" [(ngModel)]="selectedLocation" hideSingleSelectionIndicator>
              @for (location of locations; track location) {
              <mat-option [value]="location.LOCID" data-cy="login-location-option">
                {{location.Name}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <!-- Username -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-username-label">Username @if (!userName) {
              <span style="color: red;">*</span>
              }</mat-label>
          </div>
          <mat-form-field class="w-100" data-cy="auth-login-page-username-field">
            <input matInput type="text" name="username" autocomplete="username" data-cy="auth-login-page-username-input"
              maxlength="25" id="username" [(ngModel)]="userName" value="{{userName}}" (keyup.enter)="loginUser()"
              required="true" placeholder="Enter your username" (focus)="focusedField = 'user'"
              (blur)="focusedField = ''" [class.focused]="focusedField === 'user'" />
          </mat-form-field>
        </div>

        <!-- Password -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-password-label">Password @if (!password) {
              <span style="color: red;">*</span>
              }</mat-label>
            <button mat-button class="forgot-link links" (click)="forgotPasswordClicked()"
              data-cy="auth-login-page-forgot-password-btn">
              Forgot password?
            </button>
          </div>
          <div class="password-wrapper">
            <mat-form-field class="w-100" data-cy="auth-login-page-password-field">
              <input matInput data-cy="auth-login-page-password-input" [type]="showPassword ? 'text' : 'password'"
                name="password" [attr.autocomplete]="showPassword ? 'off' : 'current-password'" maxlength="25"
                id="password" (keyup.enter)="loginUser()" [(ngModel)]="password" value="{{password}}" required
                placeholder="Enter your password" (focus)="focusedField = 'password'" (blur)="focusedField = ''"
                [class.focused]="focusedField === 'password'" />
              <mat-icon matSuffix (mousedown)="showPasswords()" (mouseleave)="hidePasswords()"
                (mouseup)="hidePasswords()" class="toggle-password"
                data-cy="auth-login-page-password-toggle">{{showPassword ? 'visibility' :
                'visibility_off'}}</mat-icon>
            </mat-form-field>
          </div>
        </div>
        @if (invalidCredentials) {
        <div data-cy="auth-login-page-error-message" class="loginError">{{error}}</div>
        }
        <!-- Submit -->
        <button mat-button type="submit" class="btn-signin" (click)="loginUser()"
          [disabled]="isLoading || loadingLocations || !userName || !password" data-cy="auth-login-page-login-btn">
          @if (!isLoading) {
          Sign in
          }
          @if (isLoading) {
          <mat-spinner class="login-spinner" [diameter]="20" data-cy="auth-login-page-spinner"></mat-spinner>
          }
        </button>
      </form>
      }
      @else {
      <form (keydown.enter)="$event.preventDefault()" data-cy="auth-login-page-reset-password-form" class="login-form">

        <!-- Username -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-password-reset-username-label">Username @if
              (!userName) {
              <span style="color: red;">*</span>
              }</mat-label>
          </div>
          <mat-form-field class="w-100" data-cy="auth-login-page-password-reset-username-field">
            <input matInput type="text" name="username" autocomplete="username" data-cy="auth-login-page-username-input"
              maxlength="25" id="username" [(ngModel)]="userName" value="{{userName}}" (keyup.enter)="requestResetPassword()"
              required="true" placeholder="Enter your username" (focus)="focusedField = 'user'"
              (blur)="focusedField = ''" [class.focused]="focusedField === 'user'" />
          </mat-form-field>
        </div>

        <!-- Email -->
        <div class="field">
          <div class="label-row">
            <mat-label class="label-row" data-cy="auth-login-page-password-reset-email-label">Email @if (!userEmail) {
              <span style="color: red;">*</span>
              }</mat-label>
          </div>
          <mat-form-field class="w-100" data-cy="auth-login-page-password-reset-email-field">
            <input matInput type="email" name="userEmail" autocomplete="email"
              data-cy="auth-login-page-password-reset-email-input" maxlength="100" id="email" [(ngModel)]="userEmail"
              value="{{userEmail}}" (keyup.enter)="requestResetPassword()" required="true" placeholder="Enter your email"
              (focus)="focusedField = 'email'" (blur)="focusedField = ''" [class.focused]="focusedField === 'email'" />
          </mat-form-field>
        </div>
        @if (showChangeMessage) {
          <div data-cy="auth-login-page-reset-message" ngClass="loginError">{{requestResetPasswordMessage}}</div>
          }

        <!-- Submit -->
        <button mat-button type="submit" class="btn-signin" (click)="requestResetPassword()"
          [disabled]="isLoading || !userName || !userEmail || showChangeMessage" data-cy="auth-login-page-password-reset-request-btn">
          @if (!isLoading) {
          Request Password Change
          }
          @if (isLoading) {
          <mat-spinner class="login-spinner" [diameter]="20" data-cy="auth-login-page-spinner"></mat-spinner>
          }
        </button>
        <button mat-button class="forgot-link" (click)="showLogin()"
          data-cy="auth-login-page-password-reset-cancel-link">
          @if (!showChangeMessage) {
          Cancel
          }
          @else {
          Back to Login
          }
        </button>
      </form>
      }
      <!-- Links -->
      <div class="bottom-links">
        @if (loginType != 'referring doctor') {
        <button mat-button class="links" (click)="tdoReferrerClicked()" data-cy="auth-login-page-referrer-link">
          Referring Doctors
        </button>
        }
        @else {
        <button mat-button class="links" (click)="tdoUserClicked()" data-cy="auth-login-page-user-link">
          TDO Users
        </button>
        }
        <button mat-button class="links" (click)="tdoPatientClicked()" data-cy="auth-login-page-patient-link">
          Patient Portal
        </button>
      </div>
    </div>

    <span class="version-label">TDOS v{{appVersion}}</span>
  </div>
</div>
